/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ModelPropertyTypeDiscriminator {
    SIMPLE = 'SIMPLE',
    REF = 'REF',
    ARRAY = 'ARRAY',
}
